<!-- The container which allows you to select manual data for the network -->
<template>
    <div class="dataSelectContainer">
        <div class="field">
            <label class="label" for="dataTags">
                Add up to 10 {{ isArtists ? "artists" : "tracks" }}:
            </label>
            <div class="control">
                <input
                    id="dataTags"
                    ref="dataTags"
                    class="input"
                    type="text"
                    data-item-text="name"
                    data-item-value="id"
                    data-case-sensitive="false"
                    :data-max-tags="10"
                    data-selectable="false"
                    :placeholder="
                        'Start typing the name of a' +
                            (isArtists ? 'n artist' : ' track')
                    "
                    value=""
                />
            </div>
        </div>
        <button class="button is-primary" @click="onCancel">Cancel</button>
        <button class="button is-primary" @click="confirmData">Confirm</button>
    </div>
</template>

<script>
import BulmaTagsInput from "@creativebulma/bulma-tagsinput";
import api from "@/helpers/api";
import store from "@/store";

export default {
    name: "NetworkDataSelect",
    props: {
        // Callback function for canceling
        onCancel: Function,
        // Callback function for confirming
        onConfirm: Function,
        // Flag for whether the network is for artists or tracks
        isArtists: Boolean
    },
    mounted() {
        const tagsInput = this.$refs["dataTags"];
        // Use BulmaTagsInput with datasource of "${Api}/search?q=val"
        this.tags = new BulmaTagsInput(tagsInput, {
            source: async val =>
                await api
                    .get("search", {
                        params: {
                            q: val,
                            type: this.isArtists ? "artist" : "track"
                        },
                        headers: {
                            Authorization: `Bearer ${store.state.accessToken}`
                        }
                    })
                    // Extract data from API result
                    .then(res =>
                        this.isArtists
                            ? res.data.artists.items
                            : res.data.tracks.items
                    )
        });
        BulmaTagsInput.attach();
    },
    methods: {
        confirmData() {
            this.onConfirm(this.tags.items);
        }
    }
};
</script>

<style lang="scss" scoped>
.dataSelectContainer {
    padding: 1rem;

    .button {
        margin-right: 1rem;
    }
}
</style>
